import HeaderPortal from "components/portal/header-portal";
import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import { CommonCell } from "components/index";

export default function TechStacks() {

    const columns = [
        {
            id: "name",
            header: "Name",
            accessorKey: "name",
            cell: (props) => <CommonCell {...props} collection="tech_stack" field="name" />,
            sortable: true,
        },
        {
            id: "type",
            header: "Type",
            accessorKey: "type",
            cell: (props) => <CommonCell {...props} collection="tech_stack" field="type" />,
        },
    ];

    const fields = ["id", "name", "type"];


    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="tech_stack"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Tech Stack</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Tech Stacks"
                    endPoint="tech_stack"
                    storagekey="techstack"
                    perPage={100}
                    columns={columns}
                    meta={{ fields }}
                    sortBy="name"
                    sortOrder="aesc"
                    hidePagination={true}
                    href={(item) => item.id}
                    rowClassName="h-13"
                />
            </div>
        </div>
    );
}
